<template>
  <div>
    <menubar :permission="permission" />

    <div class="container">
      <div id="title" class="d-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-start">
          <img class="slash" src="/img/05_slash.svg" />
          <p class="h1">用語集一覧</p>
        </div>

        <div id="glossary-table-head" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
          <button class="btn btn-purple" @click="openCreateGlossaryModal()">
            新規作成
          </button>
        </div>
      </div>

      <table id="glossary-table-main" class="component_table">
        <thead>
          <tr>
            <th class="glossary-name">用語集</th>
            <th class="language-pair">言語ペア</th>
            <th class="remark">備考</th>
            <th class="number">登録<br />チーム数</th>
            <th class="number">登録<br />単語数</th>
            <th class="th--user-name">作成者</th>
            <th class="th--user-name">編集中の<br/>ユーザ</th>
            <th class="date">更新日</th>
            <th class="icon" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">DL</th>
            <th class="icon" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(glossary, index) in glossaries" :key="glossary.id" v-bind:class="[{'tr--readonly': glossary.is_editing != 0}]">
            <td class="glossary-name">
              <div class="">
                <input class="form-control" style="max-width: 100%; display: inline-block" v-show="glossary.showNameInput" type="text" :value="glossary.name" />
                <a  v-show="!glossary.showNameInput" :href="route('glossaries.show', { id: glossary.id })" target="_blank">
                  <span > {{ glossary.name }}</span>
                </a>
               <div class="mt-3" style="text-align: right;">
                  <button v-show="glossary.showNameInput" class="btn btn-red" style="font-size: 0.9rem; margin-left: 0.5rem" @click="changeGlossaryName($event, glossary.id)" >
                    更新
                  </button>
                  <button class="btn btn-purple" style="font-size: 0.9rem; margin-left: 0.5rem" @click="changeGlossaryInputElement($event, glossary.id)">
                    <span v-show="!glossary.showNameInput">変更</span>
                    <span v-show="glossary.showNameInput">戻す</span>
                  </button>
                </div>
              </div>
            </td>
            <td>
              {{ glossary.src_language_code }}
              →
              {{ glossary.trg_language_code }}
            </td>
            <td class="remark">{{ glossary.remark }}</td>
            <td>
              <a href='#' @click="openTeamDetailsModal(glossary)">
                {{ glossary.number_of_teams }}
              </a>
            </td>


            <td>{{ glossary.number_of_pairs }}</td>
            <td>{{ glossary.user.name }}
              <div v-if="glossary.user.deleted_at != null" >(削除済み)</div>
            </td>
            <td>
              <div v-if="glossary.is_editing != 0">
                <span v-if="glossary.editing_user">{{ glossary.editing_user.name }}</span>
                <span v-else>(削除済み)</span>
              </div>
              <div v-else></div>
            </td>

            <td>{{ showLocalDate(glossary.updated_at, "-") }}</td>
            <td class="icon" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
              <a :href="route('glossaries.download', { id: glossary.id })">
                <img src="/img/12_download.svg" class="btn_download" />
              </a>
            </td>
            <td class="icon" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
              <label v-if="glossary.is_editing == 0" :for="glossary.id">
                <input
                  type="checkbox"
                  :id="glossary.id"
                  :value="glossary.id"
                  v-model="selectedGlossaries"
                />
              </label>
            </td>
          </tr>
        </tbody>
      </table>

      <div id="glossary-table-foot" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
        <button class="btn btn-red" @click="deleteGlossaries()">削除</button>
      </div>
    </div>
    <!-- Modal ###########################################################################################  -->
    <modal id="create-glossary-modal" ref="createGlossaryModal">
      <template v-slot:modalTitle> 用語集の新規作成 </template>
      <template v-slot:modal-content="{ closeModal }">
        <form @submit.prevent="submit">
          <div class="mb-4">
            <label class="form-label">用語集名</label>
            <input
              type="text"
              class="form-control"
              v-model="form.name"
              required
            />
          </div>

          <div class="mb-4">
            <label class="form-label">作成方法</label><br />
            <input
              type="radio"
              id="create"
              value="create"
              v-model="form.input_method"
            />
            <label for="create">ゼロから作成</label>
            <br />
            <input
              type="radio"
              id="import"
              value="import"
              v-model="form.input_method"
            />
            <label for="import" style="margin-bottom: 0.5rem"
              >ファイルをアップロードして作成</label
            >
            <br />
            <div class="upload-file-form form-control">
              <label for="file_upload" class="filelabel">ファイル選択</label>
              <input
                type="file"
                id="file_upload"
                class="fileinput"
                ref="file"
                @input="form.file = $event.target.files[0]"
                @change="selectFile"
                :disabled="form.input_method != 'import'"
              />
              <div class="selected-file-name">
                {{ selectedFileName }}
              </div>
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label">言語ペア</label>

            <div class="lang-pair-container">
              <select class="lang-pair-select" v-model="form.src_language_code">
                <option
                  v-for="(language, index) in languages"
                  :key="index"
                  :value="language.code"
                >
                  {{ language.name }}
                </option>
              </select>

              <img class="select_pair_arrow" src="/img/13_right.svg" />

              <select class="lang-pair-select" v-model="form.trg_language_code">
                <option
                  v-for="(language, index) in languages"
                  :key="index"
                  :value="language.code"
                >
                  {{ language.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-4">
            <label class="form-label">翻訳時の適用チーム</label>
            <div class="form-group" v-for="(team, index) in teams" :key="index">
              <input
                class="form-check-input"
                type="checkbox"
                :id="team.id"
                :value="team.id"
                v-model="form.selectedTeams"
              />
              <label class="check-team-label" :for="team.id">
                {{ team.name }}
              </label>
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label">備考</label>
            <textarea class="form-control" rows="3" v-model="form.remark">
            </textarea>
          </div>

          <div class="modal-btn d-flex justify-content-evenly">
            <input
              type="button"
              class="btn btn-red"
              value="キャンセル"
              @click="closeModal()"
            />
            <input type="submit" class="btn btn-purple" value="作成" />
          </div>
        </form>
      </template>
    </modal>
    <!-- /Modal ##########################################################################################  -->
    <footerComponent />
  </div>


  <!-- 学習データの詳細を表示する ############################################################## --> 
  <modal ref="teamDetailsModal" class="">
    
    <template v-slot:modalTitle>
      登録チーム
    </template>

    <template v-if="openedGlossary != null" v-slot:modal-content="{ closeModal }"> 

      <div class="mb-3">
        <label class="form-label h5">登録チーム<span class="h6">（※複数選択可）</span></label>
        <div class="slct-tbl__wrapper">
        <table class="slct-tbl slct-tbl--team component_table">
          <thead>
            <tr>
              <th class="th--checkbox"> </th>
              <th> チーム名 </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(team, index) in teams" :key="index">
                <td>
                  <input type="checkbox" :id="team.name" :value="team.id" v-model="selectedTeamsOnUpdate" />
                </td>
                <td>
                  {{ team.name }}
                </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>

      <div class="modal-btn d-flex justify-content-evenly">
        <input type="button" class="btn btn-red" value="閉じる" @click="closeModal()"/>
        <input type="button" class="btn btn-purple" value="登録チームを更新" @click="updateGlossaryTeam()"/>
      </div>

    </template>
  </modal>

  <!-- /Model ##########################################################################################  -->

</template>

<script>
import { defineComponent, reactive } from "vue";
import { Link, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import modal from "@/Pages/Components/modal.vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import showLocalDate from '@/Pages/Components/showLocalDate.js';

export default defineComponent({
  setup() {
    const form = useForm({
      name: null,
      file: null,
      input_method: "create",
      src_language_code: "英",
      trg_language_code: "日",
      selectedTeams: [],
      remark: "",
    });
    return { form };
  },
  components: {
    Link,
    menubar,
    modal,
    footerComponent,
  },
  props: {
    glossaries: Object,
    languages: Object,
    teams: Object,
    permission: String,
    modalview: Boolean,
  },
  data() {
    return {
      selectedGlossaries: [],
      selectedTeamsOnUpdate: [],
      openedGlossary: null,
      canEdit: true,
      selectedFileName: "選択されていません",
    };
  },
  methods: {
    showLocalDate: function (date, separator) {
      return showLocalDate.showLocalDate(date, separator);
    },
    changeGlossaryName: function( $event, id ){
      const newGlossaryName = $event.srcElement.parentNode.parentNode.getElementsByTagName('input')[0].value;
      if ( newGlossaryName === '' ){
        alert('用語集名を空白にすることはできません。');
        return;
      }

      const glossary = this.getGlossaryById(id);
      glossary.name = newGlossaryName;

      this.$inertia.patch( this.route('glossaries.update', glossary.id), glossary,
      {
        onSuccess: ()=> {
        glossary.showNameInput = false;
        alert( '用語集名を変更しました。');
      },onError:(e)=>{
        alert(e.error_message);
      }});
    },
    changeGlossaryInputElement( $event, id ){
      console.log(id);
      let glossary = this.getGlossaryById(id);
      glossary.showNameInput = !glossary.showNameInput;

    },
      getGlossaryById(id) {
      return this.glossaries.filter(function (f) {
        return f.id === id;
      })[0];
    },
    updateGlossaryTeam: function () {
      if (this.selectedTeamsOnUpdate.length == 0){
        alert("利用登録するチームを一つ以上の選択してください");
        return;
      }
      if( confirm("登録チームを更新します。よろしいですか？")){
        this.$inertia.patch(
          this.route('glossaries.update', this.openedGlossary.id),
          {selectedTeams: this.selectedTeamsOnUpdate},
          {onSuccess: () => {
            alert("更新しました。");
            this.selectedTeamsOnUpdate = [];
            this.$refs.teamDetailsModal.closeModal();
          },
          onError: (e) => {
              alert(e.error_message);
            },
          }
        );
      }
    },

    openTeamDetailsModal: function(glossary){
      console.log(glossary.teams);
      this.selectedTeamsOnUpdate = glossary.teams.map((obj) => obj.id);
      this.openedGlossary = glossary;
      this.$refs.teamDetailsModal.openModal();
    },
    openCreateGlossaryModal: function () {
      this.$refs.createGlossaryModal.openModal({is_long: true});
    },
    submit: function () {
      if (!this.form.name) {
        alert("用語集名を入力してください");
        return;
      }
      if (this.form.input_method == "import" && this.form.file === null) {
        alert("ファイルを選択してください");
        return;
      }

      if (this.form.selectedTeams.length == 0) {
        alert("チームを選択してください");
        return;
      }

      if (confirm("用語集を作成します。よろしいですか？")) {
        this.$inertia.post("/glossaries", this.form, {
          onSuccess: () => {
            this.$refs.file.value = "";
            this.$refs.createGlossaryModal.closeModal();
            this.form.reset();
          },
          onError:(e)=>{
            alert(e.error_message);
          },
          only: [],
        });
        return;
      } else {
        return;
      }
    },
    deleteGlossaries: function () {
      if (this.selectedGlossaries.length == 0) {
        alert("削除列の一つ以上のチェックボックスにチェックしてください");
        return;
      }
      if (confirm("この操作はやり直せません、本当に用語集を削除しますか？")) {
        this.$inertia.delete(
          route("glossaries.destroy", this.selectedGlossaries.join(",")),
          {
            onSuccess: () => {
              alert("選択された用語集を削除しました");
              this.selectedGlossaries = [];
            },
            onError: (e) => {
              alert(e.error_message);
            },
          }
        );
      } else {
        return;
      }
    },
    downloadFile: function (glossary) {
      this.$inertia.get(this.route("glossaries.download", glossary.id), {
        onSuccess: () => {},
        only: [],
      });
    },
    selectFile: function (e) {
      this.selectedFileName = e.target.value.replace(/C:\\fakepath\\/g, "");
    },
  },
  beforeMount() {
    this.glossaries.forEach((g)=>{
      g.showNameInput = false;
    });
  }
});
</script>

<style lang="scss" scoped>
.fileinput {
  display: none;
}
.upload-file-form {
  display: flex;
  padding: 0;
}
.filelabel {
  width: 40%;
  background: #b1b0b0;
  color: #fff;
  font-size: 1em;
  text-align: center;
  padding: 5px 10px;
}
.selected-file-name {
  width: 80%;
  padding: 5px;
  background: #fff;
  color: #666;
}

#title {
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 3rem 0;
  img.slash {
    width: 3rem;
    height: 3rem;
  }
  p {
    margin: 0 0;
  }
}

#create-glossary-modal {
  color: #666666;
  .form-label {
    font-size: 1.1rem;
    color: #333333;
  }
}

#glossary-table-head {
  display: flex;
  justify-content: end;
  align-items: center;
  margin: 1rem 0;
}
#glossary-table-main {
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  thead {
    text-align: center;
    .glossary-name {
      width: 20%;
    }
    .language-pair {
      width: 6rem;
    }
    .number {
      width: 6rem;
    }
    .th--user-name {width: 7rem;}
    .date {
      width: 7rem;
    }

    .icon {
      width: 3rem;
    }
    th {
      padding: 0.7rem 0;
    }
  }
  tbody {
    text-align: center;
    border-top: 0;
    .glossary-name {
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .remark {
      text-align: left;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      // overflow: hidden;
    }
    td {
      padding: 10px;
    }
  }
}
.tr--readonly > td{ background: #e7e7eb; }


#glossary-table-foot {
  display: flex;
  justify-content: end;
  align-items: center;
  margin: 1rem 0;
}

.btn_download {
  width: 20px;
}

.lang-pair-container {
  display: flex;
  align-items: center;
}

.lang-pair-select::-ms-expand {
  display: none; /* デフォルトの矢印を無効(IE用) */
}

.lang-pair-select {
  -webkit-appearance: none;
  appearance: none; /* デフォルトの矢印を無効 */
  color: #999;
  font-size: 1rem;
  padding: 0.4rem 2.4rem 0.4rem 0.4rem;

  background-image: url(/img/16_tri.svg);
  background-repeat: no-repeat;
  background-size: 1.3rem;
  background-position: right 0.2rem center;

  border: 1px solid #ced4da;
  border-radius: 0.2rem;
}

.check-team-label {
  margin-left: 0.5rem;
}

.select_pair_arrow {
  width: 2rem !important;
  height: 2rem !important;
  margin: 0 0.5rem;
}

// 選択テーブル（AIモデル、チーム、対訳ファイル）に関するスタイル
.slct-tbl__wrapper{
  overflow-y: auto; 
  height: 300px;
}
.slct-tbl{
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  text-align: center;
}
.th--checkbox{ width: 3rem; }

</style>
